import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import React from 'react';

import { RedEntities } from './components/RedEntities';
import { YellowEntities } from './components/YellowEntities';

/**
 * Details
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function Details({ data = {} }) {
  const redEntities = data?.GetRiskDashboardStatistics?.data?.redEntityDetails || {};
  const yellowEntities = data?.GetRiskDashboardStatistics?.data?.yellowEntityDetails || {};

  return (
    <ErrorHandler location="src/pages/private/Dashboards/RiskDashboard/components/Details/Details.jsx">
      <Grid>
        <Grid.Col span={{ xs: 12 }}>
          <RedEntities data={redEntities} />
        </Grid.Col>
        <Grid.Col span={{ xs: 12 }}>
          <YellowEntities data={yellowEntities} />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
